import React from "react";

import {
  Pagination as MuiPagination,
  PaginationItem,
  SxProps,
} from "@mui/material";

import Arrow from "~/components/icons/Arrow";
import s from "./Pagination.module.scss";
import { logEvent } from "~/utils/amplitude";

interface Props {
  currentPage: number;
  count: number;
  onChange: (page: number) => void;
  canGoPreviousPage: boolean;
  canGoNextPage: boolean;
  goPreviousPage: () => void;
  goNextPage: () => void;
}

const Pagination: React.FC<Props> = ({
  currentPage,
  count,
  onChange,
  canGoPreviousPage,
  canGoNextPage,
  goPreviousPage,
  goNextPage,
}) => {
  const defaultRestyling: SxProps = {
    fontWeight: 400,
    fontSize: "1.25rem",
    margin: "0 5px",
  };

  const handlePageClick = (page: number) => {
    onChange(page);
    logEvent("Д/ Перелистнул страницу пагинации");
  };

  const handlePrevPageClick = () => {
    goPreviousPage();
    logEvent("Д/ Перелистнул страницу пагинации");
  };

  const handleNextPageClick = () => {
    goNextPage();
    logEvent("Д/ Перелистнул страницу пагинации");
  };

  return (
    <div className={s.pagination}>
      <div className={s.paginationDesktop}>
        <MuiPagination
          page={currentPage}
          count={count}
          color="primary"
          onChange={(_, page: number) => handlePageClick(page)}
          size="large"
          renderItem={(item) => (
            <PaginationItem {...item} sx={defaultRestyling} />
          )}
        />
      </div>

      <div className={s.paginationMobile}>
        <button
          className="button button--outlined"
          disabled={!canGoPreviousPage}
          onClick={handlePrevPageClick}
          style={{ color: `${!canGoPreviousPage ? "#CBD5E0" : "#5B6473"}` }}
        >
          <Arrow direction="left" />
          <span>Назад</span>
        </button>
        <button
          className="button button--outlined"
          disabled={!canGoNextPage}
          onClick={handleNextPageClick}
          style={{ color: `${!canGoNextPage ? "#CBD5E0" : "#5B6473"}` }}
        >
          <span>Вперед</span>
          <Arrow direction="right" />
        </button>
      </div>
    </div>
  );
};

export default Pagination;
